module.exports = __webpack_public_path__ + "img/best-price.3e59bbdf.svg";